<mobiledelivery
  style="background: white; border-radius: 4px; width: 690px"
  [hideHeader]="true"
  [dragged_data]="dragged_data"
  [dialogId]="dialogId"
  [upload_file]="upload_file"
  [payload]="data"
  [origin]="origin"
  [suggestion_id]="suggestion_id"
  [single_upload]="single_upload"
></mobiledelivery>
